import React from 'react';
import { PiDotsThreeOutlineVertical } from 'react-icons/pi';
import ModalContainer from '../ModalContainer';
import DeleteProjectModal from '../DeleteProjectModal';
import { ProjectCardStyled, ReponseMenu, MenuBtn, StyleItem } from './ProjectCard.styles';
import folderIcon from '../../assets/icon-folder-files.svg';
import CreatProjectModal from '../CreatProjectModal';
import { useNavigate } from 'react-router-dom';

const ProjectCard = ({ projectCardsData }) => {
  const navigate = useNavigate();
  return (
    <>
      {projectCardsData?.map(card => (
        <ProjectCardStyled key={card.project_id}>
          <div className="card-header">
            <div className="img-box">
              <img src={folderIcon} alt="img" />
            </div>
            <ReponseMenu
              menuButton={
                <MenuBtn>
                  <PiDotsThreeOutlineVertical />
                </MenuBtn>
              }>
              <ModalContainer
                width="750"
                title="Edit Project"
                content={({ onClose }) => <CreatProjectModal onClose={onClose} isEdit={card} />}
                btnComponent={({ onClick }) => (
                  <StyleItem onClick={onClick}>
                    <div className="text">Edit project</div>
                  </StyleItem>
                )}
              />
              <ModalContainer
                width="750"
                title="Confirm Project Deletion"
                content={({ onClose }) => <DeleteProjectModal onClose={onClose} isEdit={card} />}
                btnComponent={({ onClick }) => (
                  <StyleItem onClick={onClick}>
                    <div className="text" style={{ color: 'rgba(215, 65, 32, 1)' }}>
                      Delete Project
                    </div>
                  </StyleItem>
                )}
              />
              <StyleItem onClick={() => navigate(`/project/${card.project_id}`)}>
                <div className="text">See Details</div>
              </StyleItem>
            </ReponseMenu>
          </div>
          <div className="text-box">
            <strong className="title">{card.name}</strong>
            <button>{card?.sessions?.length === 0 && 'Create Threads now'} </button>
            <p>
              {card?.sessions?.length !== 0 &&
                `${card?.sessions?.length} Chat Thread${card?.sessions?.length > 1 ? 's' : ''}`}
            </p>
          </div>
          <div className="card-footer">
            <span className="date">{card.created_at}</span>
          </div>
        </ProjectCardStyled>
      ))}
    </>
  );
};

export default ProjectCard;
